import { configure } from 'mobx';

export function initMobx() {
  if (!window.Proxy) {
    configure({ useProxies: 'never' });
  }
}
